const StadiumFloodlights = () => {
  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden z-0">
      {/* Top-left floodlight glow */}
      <div 
        className="absolute -top-32 -left-32 w-96 h-96 rounded-full blur-3xl opacity-20"
        style={{
          background: 'radial-gradient(circle, hsl(var(--floodlight)) 0%, hsl(var(--floodlight-warm)) 30%, transparent 70%)'
        }}
      />
      
      {/* Top-right floodlight glow */}
      <div 
        className="absolute -top-32 -right-32 w-96 h-96 rounded-full blur-3xl opacity-20"
        style={{
          background: 'radial-gradient(circle, hsl(var(--floodlight)) 0%, hsl(var(--floodlight-warm)) 30%, transparent 70%)'
        }}
      />
      
      {/* Center top light rays */}
      <div 
        className="absolute top-0 left-1/2 -translate-x-1/2 w-[150%] h-[600px] opacity-10"
        style={{
          background: 'linear-gradient(180deg, hsl(var(--floodlight) / 0.3) 0%, transparent 100%)',
          clipPath: 'polygon(35% 0, 65% 0, 85% 100%, 15% 100%)'
        }}
      />
      
      {/* Diagonal light rays from corners */}
      <div 
        className="absolute top-0 left-0 w-[800px] h-[800px] opacity-5"
        style={{
          background: 'linear-gradient(135deg, hsl(var(--floodlight-warm)) 0%, transparent 50%)',
          clipPath: 'polygon(0 0, 40% 0, 0 40%)'
        }}
      />
      
      <div 
        className="absolute top-0 right-0 w-[800px] h-[800px] opacity-5"
        style={{
          background: 'linear-gradient(225deg, hsl(var(--floodlight-warm)) 0%, transparent 50%)',
          clipPath: 'polygon(100% 0, 100% 40%, 60% 0)'
        }}
      />
      
      {/* Subtle shimmer effect */}
      <div 
        className="absolute top-0 left-0 right-0 h-64 opacity-5"
        style={{
          background: 'linear-gradient(180deg, hsl(var(--floodlight)) 0%, transparent 100%)'
        }}
      />
    </div>
  );
};

export default StadiumFloodlights;
